import axios from "axios";
import { Button } from "@material-ui/core";
import * as React from "react";
import { BackgroundLogin } from "../shared/layout/background-login/BackgroundLogin";
import { CustomSnackbar } from "../shared/snackbar/CustomSnackbar";
import { getError } from "src/services/ErrorService";

// tslint:disable-next-line:no-empty-interface
export interface IForgotPasswordProps {
  onBack: () => void;
}

// tslint:disable-next-line:no-empty-interface
export interface IForgotPasswordState {
  alert: {
    open: boolean;
    msg: string;
  };
  email: string;
}

export class ForgotPassword extends React.Component<
  IForgotPasswordProps,
  IForgotPasswordState
> {
  constructor(props: IForgotPasswordProps) {
    super(props);
    this.state = {
      alert: {
        msg: "",
        open: false,
      },
      email: "",
    };
  }

  public render() {
    const { msg, open } = this.state.alert;

    return (
      <>
        <CustomSnackbar msg={msg} open={open} onClose={this.closeAlert} />
        <BackgroundLogin>
          <div className="background-login-box">
            <div className="background-login-field">
              <label>E-Mail</label>
              <input
                autoComplete="off"
                type="text"
                onChange={this.handleChangeEmail}
              />
            </div>
            <Button type="button" onClick={this.resetPassword}>
              Ok
            </Button>
            <a onClick={this.props.onBack}>Voltar</a>
            <footer className="background-login-footer-text">
              Digite seu endereço de e-mail e nós lhe enviaremos instruções
              sobre como criar uma nova senha.
            </footer>
          </div>
        </BackgroundLogin>
      </>
    );
  }

  private handleChangeEmail = (event: React.FormEvent<HTMLInputElement>) => {
    this.setState({ email: event.currentTarget.value });
  };

  private resetPassword = async () => {
    const HOST = process.env.API;
    const email = this.state.email;

    if (!email) {
      return this.openAlert("Nenhum e-mail foi informado");
    }

    try {
      const response = await axios.post(`${HOST}forgot-password`, { email });
      if (response.data) {
        this.openAlert("Verifique a caixa de entrada do seu e-mail");
        this.setState({ email: "" });
        setTimeout(() => this.props.onBack(), 4000);
      }
    } catch (err) {
      const erro = getError(err);
      this.openAlert(erro.message);
      setTimeout(() => this.props.onBack(), 4000);
    }
  };

  private openAlert = (msg: string) => {
    this.setState({ alert: { msg, open: true } });
  };

  private closeAlert = () => {
    this.setState({ alert: { msg: "", open: false } });
  };
}



// WEBPACK FOOTER //
// ./src/component/forgot-password/ForgotPassword.tsx